import React from "react";

//icons
import { HiOutlineCheckCircle } from "react-icons/hi";

const ThankYouModal = ({ onLoginNowButtonClick }) => {
  return (
    <div className="thank_you_modal">
      <div className="container">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <HiOutlineCheckCircle
            style={{ fontSize: "100px", color: "#39B5B2" }}
          />
        </div>
        <div className="w-100">
          <h3 style={{ marginTop: "20px" }}>Thank you!</h3>
          <p
            style={{
              marginTop: "10px",
              fontSize: "12px",
              marginBottom: "0px",
              lineHeight: 1.2,
            }}
          >
          </p>
          <div
            onClick={onLoginNowButtonClick}
            style={{
              cursor: "pointer",
              backgroundColor: "#967F65",
              borderRadius: "20px",
              marginTop: "40px",
            }}
          >
            <p style={{ color: "white", fontWeight: "500", padding: "5px" }}>
              Log In
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouModal;
